/**
 * Correos de otra persona, desde Personas (solo ADMIN). Es el mismo `FormularioAvisos` de «Mi cuenta»,
 * pero contra `/api/usuarios/:id/correos` y dentro de la carcasa común `componentes/Dialogo`. Cada
 * cambio se guarda al instante, así que basta con «Listo» para cerrar.
 */
import { useId } from 'react';
import { ETIQUETA_ROL, type Usuario } from '@cdtec-backlog/contrato';
import { Dialogo } from '../../componentes/Dialogo';
import { FormularioAvisos } from './FormularioAvisos';
import './DialogoCorreosPersona.css';

export function DialogoCorreosPersona({
  persona,
  yoId,
  onCerrar,
}: {
  persona: Pick<Usuario, 'id' | 'nombre' | 'email' | 'rol'>;
  /** Id de quien edita: si es la misma persona, se refresca también Mi cuenta. */
  yoId?: number;
  onCerrar: () => void;
}) {
  const id = useId();
  return (
    <Dialogo
      etiquetadoPor={`${id}-titulo`}
      descritoPor={`${id}-ayuda`}
      className="dialogo-correos"
      onCancelar={onCerrar}
    >
      <h2 id={`${id}-titulo`} className="dialogo__titulo">
        Correos de {persona.nombre}
      </h2>
      <p id={`${id}-ayuda`} className="dialogo__ayuda dialogo-correos__ayuda">
        {persona.email} · {ETIQUETA_ROL[persona.rol]}. Los cambios se guardan al instante y la
        persona verá «Lo cambió un administrador».
      </p>
      <FormularioAvisos destino={persona.id} nombre={persona.nombre} yoId={yoId} plano />
      <div className="dialogo__acciones">
        <button type="button" className="boton boton--primario" onClick={onCerrar}>
          Listo
        </button>
      </div>
    </Dialogo>
  );
}
